import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme, useMediaQuery, Typography, Box } from "@mui/material";
import ConasLogo from "./assets/conas_logo.png";
import ConasLogoSmall from "./assets/logo512.png";
import { themeMain } from "../components/wrapper/CThemeProvider";

function Header() {
  const [projectTitle, setProjectTitle] = useState("");
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    // Get the current URL path
    const currentPath = window.location.pathname;

    const routeToTitleMap = {
      "/": "Global Location Data",
    };

    // Check if the current path is in the mapping
    if (routeToTitleMap[currentPath]) {
      setProjectTitle(routeToTitleMap[currentPath]);
    } else {
      setProjectTitle("");
    }
  }, []);

  return (
    <AppBar
      sx={{
        backgroundColor: themeMain.palette.mainbg.main,
        padding: "0.5em 1em",
      }}
    >
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={3} sm={2} display="flex" justifyContent="flex-start">
          <Box
            component="img"
            src={isXs ? ConasLogoSmall : ConasLogo}
            alt="Click to see All Services"
            sx={{
              maxWidth: "100%",
              maxHeight: "100%",
              cursor: "pointer",
              objectFit: "contain",
              height: "2em",
              width: "auto",
              marginLeft: isXs ? 0 : "1em", // Adjust margin for better alignment
            }}
          />
        </Grid>

        <Grid
          item
          xs={6}
          sm={8}
          md={6}
          lg={6}
          xl={6}
          sx={{
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography
            color="secondary"
            fontSize={isXs ? "1.5rem" : "2rem"}
            whiteSpace="nowrap"
          >
            {projectTitle}
          </Typography>
        </Grid>

        <Grid item xs={3} sm={2}></Grid>
      </Grid>
    </AppBar>
  );
}

export default Header;
